<script>
    import Button from "$lib/atoms/Button.svelte";
    import { ArrowRight } from "lucide-svelte";
    import FAQItem from "./FAQItem.svelte";
    import { t } from '$lib/i18n.js';
    import { generateStructuredData } from '$lib/seo.js';

    export let page;

    $: langStr = 'components.faq.' + page + '.';

    const questions = 5;

    // Build FAQPage structured data (AEO) from the same Q&A the section renders, so
    // answer engines can extract a featured-snippet-ready FAQ for this page.
    $: faqStructuredData = generateStructuredData('FAQPage', {
        questions: Array.from({ length: questions }, (_, index) => ({
            question: $t(langStr + 'accordions.' + (index + 1) + '.question'),
            answer: $t(langStr + 'accordions.' + (index + 1) + '.answer')
        }))
    });
</script>

<svelte:head>
    {@html `<script type="application/ld+json">${JSON.stringify(faqStructuredData)}</script>`}
</svelte:head>

<section>
    <div class="max-width">
    <div class="col">
        <div class="titles">
            <h2>{$t('components.faq.title_first_line')}</h2>
            <h2 class="accent">{$t('components.faq.title_second_line')}</h2>
        </div>
        <Button
            class="btn"
            icon={ArrowRight}
            label="{$t('components.faq.cta')}"
            backgroundColor="var(--surface)"
            textColor="var(--on-surface)"
            href="https://auting.notion.site/"
            target="_blank"
            rel="noopener noreferrer"
        />
    </div>
    <div class="col">
        {#each Array(questions) as _, index (index)}
            <FAQItem
                question="{$t(langStr+'accordions.' + (index + 1) + '.question')}"
                answer="{$t(langStr+'accordions.' + (index + 1) + '.answer')}"
                isOpen={false}
            />
        {/each}
        
    </div>
    </div>
</section>

<style>
    section {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
        gap: 16px;
        padding: 16px;
        background-color: var(--on-surface);
        padding-top: 120px;
        padding-bottom: 120px;
    }

    .max-width {
        max-width: var(--max-width);
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
        gap: 40px;
    }

    .col {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 0px;
        flex: 1;
    }

    h2 {
        color: var(--surface);
        margin: 0;
        padding: 0;
    }

    h2.accent {
        color: var(--orange);
        font-family: var(--font-heading);
    }

    .titles {
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        gap: 0px;
    }

    @media (max-width: 768px) {
        section {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding-top: 120px;
            padding-bottom: 120px;
        }

        .col {
            width: 100%;
            align-items: flex-start;
        }

        .titles {
            text-align: flex-start;
        }

        .max-width {
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
    }
</style>
